export const getSupportedMimeType = () => {
  // Prefer Opus in WebM
  const opusWebM = "audio/webm; codecs=opus";
  if (MediaRecorder.isTypeSupported(opusWebM)) {
    return opusWebM;
  }

  // Otherwise, fallback to MP4/AAC
  const aacMP4 = "audio/mp4; codecs=mp4a.40.2";
  if (MediaRecorder.isTypeSupported(aacMP4)) {
    return aacMP4;
  }

  // Or 'audio/ogg; codecs=opus' (Firefox)
  const opusOgg = "audio/ogg; codecs=opus";
  if (MediaRecorder.isTypeSupported(opusOgg)) {
    return opusOgg;
  }

  // If we get here, no supported mime types for MediaRecorder
  return "";
};

export const getAudioFileType = () => {
  const mimeType = getSupportedMimeType();
  switch (mimeType) {
    case "audio/webm; codecs=opus":
      return ".webm";
    case "audio/mp4; codecs=mp4a.40.2":
      return ".mp4";
    case "audio/ogg; codecs=opus":
      return ".ogg";
    default:
      return "";
  }
};
